import { render, staticRenderFns } from "./QuizStatus.vue?vue&type=template&id=0528a7f0"
import script from "./QuizStatus.vue?vue&type=script&lang=js"
export * from "./QuizStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports